import { connect } from 'react-redux'
import BulkAction from './bulk-action'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  removeInvitation,
  markAsSeen,
  markAsUnseen
} from '../../../../../../stores/current-invitations/current-invitations.actions'

const mapDispatchToProps = dispatch => ({
  onMarkAsSeen: invitations =>
    invitations.forEach(
      invitation => !invitation.seen && dispatch(markAsSeen(invitation.id))
    ),
  onMarkAsUnseen: invitations =>
    invitations.forEach(
      invitation => invitation.seen && dispatch(markAsUnseen(invitation.id))
    ),
  onRemove: invitations =>
    invitations.forEach(invitation =>
      dispatch(removeInvitation(invitation.id)).catch(errorHandler)
    )
})

export default connect(null, mapDispatchToProps)(BulkAction)
